import { render, staticRenderFns } from "./BilibiliEmoji.vue?vue&type=template&id=e1039c80&"
import script from "./BilibiliEmoji.vue?vue&type=script&lang=js&"
export * from "./BilibiliEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports